module.exports = __webpack_public_path__ + "img/cave80.74b677da.jpg";